module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-number"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Contents#p1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PART ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "part-title"
  }, [_vm._v("Watchers of Water")]), _vm._v(" "), _c('p', {
    staticClass: "extract-space-after"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("‘Only what changes can remain.’")])]), _vm._v(" "), _c('p', {
    staticClass: "extract-source"
  }, [_vm._v("Wei Wulong, ‘The Path of Tea’")]), _vm._v(" "), _c('p', {
    staticClass: "extract-source"
  }, [_vm._v("7th century of Old Qian time")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e87f8dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Part1.vue
// module id = 69
// module chunks = 0